<template>
  <v-app id="searchNotInAres">
    <v-main>
      <v-container v-show="showParameters" fluid>
       <v-row dense no-gutters> 

          <v-col cols="2" class="mx-2">
            <v-menu
              v-model="abnDatemenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
            <template v-slot:activator="{ on }">
            <v-text-field
              v-model="param.abnDate" 
              label="ABN date"
              clearable
              v-on="on"
            ></v-text-field>
            </template>
            <v-date-picker v-model="param.abnDate2" :first-day-of-week="1" @input="param.abnDate = $moment(param.abnDate2).format('DD-MM-YYYY'); abnDatemenu = false"></v-date-picker>
            </v-menu>  
          </v-col>  

      </v-row>

      <v-row>
          <v-col cols="1">
            <v-btn class="primary ma-0" small @click="getHkgm">Search</v-btn>
          </v-col> 
      </v-row>

      </v-container>

      <v-container fluid>
       <v-btn v-show="!showParameters" class="primary ma-0" small @click="showParameters = true">Show parameters</v-btn> 

      

      <v-row v-if="!showParameters" dense no-gutters>
        

         
        <v-card class="px-2">

          Datum {{ result.abnDate }} <br>
          ABN begin saldo {{result.abnBeginSaldo}} <br>
          ABN Mutaties {{result.abnMutatieSaldo}} <br>
          ABN Eind saldo {{result.abnEindSaldo}} <br>

          <br>
         
          ARES mutaties saldo {{result.aresMutatieSaldo}} <br>
          Niet in ARES muaties saldo {{result.notAresMutatieSaldo}} <br>

          <!--
            <v-text-field
            v-model="search"
              label="Search"
              single-line
              hide-details
             >
            </v-text-field>
        
            <v-data-table 
            :items="items" 
            :items-per-page="50" 
            :footer-props="{'items-per-page-options': [50, 100, 200, 300, 500]}"
            :headers="headers"
            :search="search"   
           
            >
            <template v-slot:item="props">
              <tr>
              <td @click="$router.open('/huov/onHuov/' + props.item.huov_encrid)"><a> {{props.item.huov_code}} </a></td>
              <td><v-chip :color=props.item.hust_kleur>{{props.item.hust_code}}</v-chip></td>
              <td>{{props.item.huov_ota_code}}</td>
              <td @click="$router.open('/huis/onHuis/' + props.item.huis_encrid)"><a> {{props.item.huis_code}} </a></td>
              <td>{{props.item.huis_naam}}</td>
              <td>{{ $moment(props.item.huov_dt).format("DD-MMM-YYYY HH:mm ddd") }}</td>
              <td>{{props.item.huov_nights}}</td>
              <td>{{ $moment(props.item.huov_van_dat).format("DD-MMM-YYYY ddd") }}</td>
              <td>{{ $moment(props.item.huov_tm_dat).format("DD-MMM-YYYY ddd") }}</td>
             
              <td @click="$router.open('/klnt/onKlnt/' + props.item.klnt_encrid)"><a> {{props.item.klnt_naam}} </a></td>
              <td align="right">{{props.item.invoice}}</td>
              <td align="right">{{props.item.payment}}</td>
              <td align="right">{{props.item.balance}}</td>
              </tr>
            </template>
            </v-data-table>
          -->
        </v-card>
      
        </v-row>
    </v-container>
    </v-main>
    <navBar :title="'Ares - Finance'" :home="true" type="finance"/>
  </v-app>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  data() {
    return {
      results: false,
      showParameters: true,
      items: [],
      result: {},
      param: {},
      abnDatemenu: false,

      search: '',
      headers: [
        {text: 'Id', value: 'huov_code'},
        {text: 'Status', value: 'hust_code'},
        {text: 'Airbnb Id', value: 'huov_ota_code'},
        {text: 'Accommodation', value: 'huis_code'},
        {text: 'Acco naam', value: 'huis_naam'},
        {text: 'Booking', value: 'huov_dt'},
        {text: 'Nights', value: 'huov_nights'},
        {text: 'Arrival', value: 'huov_van_dat'},
        {text: 'Departure', value: 'huov_tm_dat'},
        {text: 'Guest', value: 'klnt_naam'},
        {text: 'Invoice', value: 'invoice'},
        {text: 'Payment', value: 'payment'},
        {text: 'Balance', value: 'balance'}
      ]
    }  
  },
  created() {
      this.$axios
      .post("ares/json/ares/task/fin/abn/getSearchNotInAresParam.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getSearchNotInAresParam"
        },
        getSearchNotInAresParam: {}
      })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
           this.param = res.data.getSearchNotInAresParam;
        }
      });

  },
  methods: {
    /*
    dateToDMY (dat) {
        return dat ? this.$moment(dat).format('DD-MM-YYYY') : ''
      },
     */ 
     getHkgm() {
      this.results = true;
      this.showParameters = false;
      this.$axios
        .post("ares/json/ares/task/fin/abn/searchNotInAres.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchNotInAres"
          },
          searchNotInAres: {
            abnDate: this.param.abnDate
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            console.log("HIER");
            this.items = res.data.searchNotInAres;
            this.result = res.data;
           
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};

</script> 
